/**
 * File in attesa di invio (anteprima con didascalia). Condiviso tra la lista messaggi
 * (trascina e rilascia sulla chat) e la barra di scrittura (graffetta, incolla), che
 * mostra l'anteprima. Ogni file ha la sua didascalia.
 */

import { create } from 'zustand';

export interface DraftAttachment {
  id: string;
  file: File;
  caption: string;
}

interface AttachmentState {
  chatId: string | null;
  items: DraftAttachment[];
  add: (chatId: string, files: File[]) => void;
  setCaption: (id: string, caption: string) => void;
  remove: (id: string) => void;
  clear: () => void;
}

let seq = 0;

export const useAttachmentStore = create<AttachmentState>((set) => ({
  chatId: null,
  items: [],
  add: (chatId, files) => set((s) => {
    if (files.length === 0) return s;
    // File trascinati in un'altra chat: si riparte da zero, mai allegati della chat precedente.
    const base = s.chatId === chatId ? s.items : [];
    return {
      chatId,
      items: [...base, ...files.map((file) => ({ id: `att-${Date.now()}-${seq++}`, file, caption: '' }))].slice(0, 30),
    };
  }),
  setCaption: (id, caption) => set((s) => ({ items: s.items.map((i) => (i.id === id ? { ...i, caption } : i)) })),
  remove: (id) => set((s) => ({ items: s.items.filter((i) => i.id !== id) })),
  clear: () => set({ items: [], chatId: null }),
}));
